import { postCulpritAcceptOrRejectReceivedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCulpritAcceptOrRejectRecievedImages/postCulpritAcceptOrRejectRecievedImagesFunction';
import { postCulpritRejectOrAcceptParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCulpritAcceptOrRejectRecievedImages/postCulpritAcceptOrRejectRecievedImages.type';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const postCulpritAcceptOrRejectReceivedImagesOptions =
  (): MutationOptions<
    AxiosResponse<any, any>,
    Error,
    postCulpritRejectOrAcceptParamsType
  > => ({
    mutationKey: ['POST_CULPRIT_ACCEPT_OR_REJECT_RECEIVED_IMAGES_OPTIONS'],
    mutationFn: ({ data, id }) =>
      postCulpritAcceptOrRejectReceivedImagesFunction({ id, data }),
  });
